import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, forwardRef } from '@angular/core';
import { BehaviorSubject, Observable, Subject, map } from 'rxjs';
import { Customer, DeleteLote, EmbargoedMerchandise, GetLote, Lote, LocationInterface, Material, MaterialGroup, Packaging, PostLote, PreviousRegistration, UpdateLote, Origen, FileBody, FileUrl, TipoEntrada, EntradaCrear, Entrada, EntradaActualizar, SalidaCatalogo, SalidaResponse, Salida, LoteId, SalidaLista, SalidaUpdate, SalidaTransferencia, SalidaSinPresentacion, CustomerBusinessName, MessageError, Entry, OutputType, loteFile, NationalPorts, EntriesByBatch, Transport, TransportFile, TransportCreate, TranportLine, ExportTransport, ExportTransportCreate, CustomName, Constans } from 'src/app/interfaces/lotes.interfaces';
import { GLOBAL } from 'src/app/_config/config';
import { BatchesAvailableTransfer, EntryResponse, ExportEntry, ExportOutput, ExportOutputType, ExportTransportOutput, ExportationBatch, FileBatchExportation, FileEntryExportation, MembratedLetter, OuputResponse, ResponseCreateBatchExportation, deleteResponse } from 'src/app/interfaces/exportationBatches.interfaces';
import { TonsPerYardService } from '../tons-per-yard/tons-per-yard.service';

/**
 * Servicio central que gestiona los lotes de importación y exportación junto
 * con todas sus operaciones asociadas: catálogos, entradas, salidas, transportes,
 * pedimentos, cartas membretadas y archivos, además del estado y el ordenamiento
 * de las tablas de lotes y los datos de los formularios.
 */
@Injectable({
  providedIn: 'root'
})
export class LoteService {
  currentExportBatch: number = 0;
  currentCabotageBatch: number = 0;
  granel: boolean = false;
  listSelect: string[] = ['request_number', 'transport_type_id', 'trailer_id', 'location_id','transport_line'];
  createdEntry: boolean = false;
  loteExport: boolean = false;
  loteCabotageImp: boolean = false;
  loteCabotageExp: boolean = false;
  overlayError: boolean = false;
  loader: boolean = false;
  loteInfo: LoteId = {
    registry_number:                   0,
    operation_number:                  '',
    id_master:                         '',
    ship_name:                         '',
    customer_lot_number:               '',
    customer_id:                       0,
    business_name_client:              '',
    docking_date:                      '',
    undocking_date:                    '',
    material_group_id:                 0,
    material_id:                       0,
    packing_id:                        0,
    observations:                      '',
    tonnage:                           0,
    quantity_pieces:                   0,
    origin:                            '',
    location_id:                       0,
    days_free_storage:                 0,
    storage_fee:                       0,
    special_storage_rate:              0,
    consignee_name:                    '',
    address_consignee:                 '',
    commercial_value:                  '',
    bill_lading:                       '',
    shipper_receiver:                  '',
    address_shipper_receiver:          '',
    damage_violation_record:           '',
    identification_stored_merchandise: '',
    volume_occupied_merchandise:       '',
    merchandise_fiscalized_area:       false,
    client_name:                       '',
    material_group_name:               '',
    material_name:                     '',
    packaging:                         '',
    location_name:                     '',
    address:                           '',
    input_tons:                        0,
    output_tons:                       0,
    remaining_tons:                    0,
  };
  loteInfoExport: ExportationBatch = {
    bl_lot_id:                               0,
    customer_lot_number:                     '',
    customer_id:                             0,
    client_name:                             '',
    id_business_name:                        0,
    docking_date:                            '',
    undocking_date:                          '',
    material_group_id:                       0,
    material_group_name:                     '',
    material_id:                             0,
    material_name:                           '',
    packing_id:                              0,
    packaging:                               '',
    observations:                            '',
    tonnage:                                 0,
    quantity_pieces:                         0,
    location_id:                             0,
    days_free_storage:                       0,
    storage_fee:                             0,
    special_storage_rate:                    0,
    consignee_name:                          '',
    address_consignee:                       '',
    commercial_value:                        0,
    shipper_receiver:                        '',
    address_shipper_receiver:                '',
    damage_violation_record:                 '',
    identification_stored_merchandise:       '',
    volume_occupied_merchandise:             0,
    merchandise_fiscalized_area:             false,
    pama_number:                             '',
    fiscal_folio_cfdi:                       '',
    total_amount_cfdi:                       '',
    total_amount_presentation:               '',
    amount_merchandise_deposit:              '',
    compensation_amount:                     '',
    address:                                 '',
    container_dimension:                     '',
    container_type:                          '',
    number_container_seals:                  '',
    number_container_locks:                  '',
    unconsolidated_container:                '',
    deconsolidated_store:                    '',
    unconsolidated_means_transport:          '',
    consolidated_container:                  '',
    consolidated_store:                      '',
    consolidated_means_transport:            '',
    file_export_batch:                       '',
    input_tons:                              0,
    output_tons:                             0,
    remaining_tons:                          0,
  };
  lotes: GetLote[] = [];
  private _lotes: GetLote[] = [];
  lotesExportacion: ExportationBatch[] = [];
  private _lotesExportacion: ExportationBatch[] = [];
  importEntries: EntriesByBatch[] = [];
  importEntriesFilter: EntriesByBatch[] = [];
  exportEntries: ExportEntry[] = [];
  exportEntriesFilter: ExportEntry[] = [];
  importOutputs: OutputType[] = [];
  importOutputsFilter: OutputType[] = [];
  exportOutputs: ExportOutput[] = [];
  exportOutputsFilter: ExportOutput[] = [];
  _batchListError: boolean = false;
  private exportBatchesYearSubject = new BehaviorSubject<number>(new Date().getFullYear());
  exportBatchesYear$ = this.exportBatchesYearSubject.asObservable();

  /**
   * Establece el año de los lotes de exportación a consultar.
   * @param year - Año a establecer.
   */
  setExportBatchesYear(year: number) {
    this.exportBatchesYearSubject.next(year);
  }

  /**
   * Año actualmente seleccionado para los lotes de exportación.
   * @returns Año seleccionado.
   */
  get exportBatchesYear(): number {
    return this.exportBatchesYearSubject.getValue();
  }

  /**
   * Lista filtrada de lotes de importación.
   * @returns Lista filtrada de lotes de importación.
   */
  get lotesFilter() {
    return this._lotes;
  }

  set lotesFilter(value: GetLote[]) {
    this._lotes = value;
  }

  /**
   * Lista filtrada de lotes de exportación.
   * @returns Lista filtrada de lotes de exportación.
   */
  get lotesExportacionFilter() {
    return this._lotesExportacion;
  }

  set lotesExportacionFilter(value: ExportationBatch[]) {
    this._lotesExportacion = value;
  }

  /**
   * Indica si ocurrió un error al cargar el listado de lotes.
   * @returns `true` si hubo error al cargar la lista.
   */
  get batchListError() {
    return this._batchListError;
  }

  set batchListError(_batchListError: boolean) {
    this._batchListError = _batchListError;
  }

  constructor(
    @Inject(forwardRef(() => HttpClient)) private http: HttpClient,
    @Inject(forwardRef(() => TonsPerYardService)) private amountsPerYardSvc: TonsPerYardService,
  ) { }

  /**
   * Obtiene las constantes de configuración del sistema.
   * @returns Observable con las constantes.
   */
  getConstans(): Observable<Constans> {
    const url: string = `${GLOBAL.url}${GLOBAL.constans}`;
    return this.http.get<Constans>(url);
  }

  /**
   * Carga y prepara la tabla de lotes de exportación de un año, aplicando el
   * mapeo de nombres y el ordenamiento, y gestionando los estados de carga y error.
   * @param year - Año a consultar.
   */
  getLotesExportacionTabla(year: number) {
    this.lotesExportacion = [];
    this.lotesExportacionFilter = [];
    this.loader = true;
    this.listExportationBatchByYear(year)
    .subscribe({
      next: lotes => {
        if (!Array.isArray(lotes)) {
          this.batchListError = true;
          return;
        }
        lotes = [...this.idToName(lotes)];
        lotes = [...this.sortArray<ExportationBatch>(lotes, 'registry_number')];
        this.lotesExportacion = [...lotes];
        this.lotesExportacionFilter = [...lotes];
        this.loader = false;
      },
      error: (e) => {
        this.loader = false;
        this.overlayError = true;
      },
    });
  }

  /**
   * Obtiene el catálogo de ubicaciones.
   * @returns Observable con la lista de ubicaciones.
   */
  getLocations(): Observable<LocationInterface[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.locations}`
    return this.http.get<LocationInterface[]>(url);
  }

  /**
   * Obtiene el catálogo de tipos de empaque.
   * @returns Observable con la lista de empaques.
   */
  getPackaging(): Observable<Packaging[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.packaging}`;
    return this.http.get<Packaging[]>(url);
  }

  /**
   * Obtiene el catálogo de grupos de material.
   * @returns Observable con la lista de grupos de material.
   */
  getMaterialGroup(): Observable<MaterialGroup[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.material_group}`;
    return this.http.get<MaterialGroup[]>(url);
  }

  /**
   * Obtiene el catálogo de estatus de modulación.
   * @returns Observable con la lista de estatus de modulación.
   */
  getModulationStatus(): Observable<MaterialGroup[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.modulationStatus}`;
    return this.http.get<MaterialGroup[]>(url);
  }

  /**
   * Obtiene el catálogo de nombres de aduana.
   * @returns Observable con la lista de nombres de aduana.
   */
  getCustomNameList(): Observable<CustomName[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.customName}`;
    return this.http.get<CustomName[]>(url);
  }

  /**
   * Obtiene los materiales de un grupo de material.
   * @param id - Identificador del grupo de material.
   * @returns Observable con la lista de materiales.
   */
  getMaterial( id: string ): Observable<Material[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.material}${id}`;
    return this.http.get<Material[]>(url);
  }

  /**
   * Obtiene el catálogo de clientes.
   * @returns Observable con la lista de clientes.
   */
  getCustomer(): Observable<Customer[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.customer}`;
    return this.http.get<Customer[]>(url);
  }

  /**
   * Obtiene las razones sociales de un cliente.
   * @param id - Identificador del cliente.
   * @returns Observable con la lista de razones sociales.
   */
  getCustomerBusinessName( id: number ): Observable<CustomerBusinessName[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.customerBusinessName}${id}`;
    return this.http.get<CustomerBusinessName[]>(url);
  }

  /**
   * Obtiene el catálogo de orígenes (países).
   * @returns Observable con la lista de orígenes.
   */
  getOrigen(): Observable<Origen[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.countries}`;
    return this.http.get<Origen[]>(url);
  }

  /**
   * Obtiene el catálogo de puertos nacionales.
   * @returns Observable con la lista de puertos nacionales.
   */
  getNationalPorts(): Observable<NationalPorts[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.nationalPorts}`;
    return this.http.get<NationalPorts[]>(url);
  }

  /**
   * Obtiene los registros previos asociados a un lote.
   * @param id - Identificador del lote.
   * @returns Observable con los registros previos.
   */
  getPreviousRegistration( id: number ): Observable<PreviousRegistration[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.previousRegistration}${id}`;
    return this.http.get<PreviousRegistration[]>(url);
  }

  /**
   * Obtiene la mercancía embargada asociada a un lote.
   * @param id - Identificador del lote.
   * @returns Observable con la mercancía embargada.
   */
  getEmbargoedMerchandise( id: number ): Observable<EmbargoedMerchandise[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.embargoedMerchandise}${id}`;
    return this.http.get<EmbargoedMerchandise[]>(url);
  }

  /**
   * Obtiene la URL de un archivo a partir de los datos proporcionados.
   * @param id - Datos que identifican el archivo a consultar.
   * @returns Observable con la URL del archivo.
   */
  getFile( id: FileBody ): Observable<FileUrl> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.file}`;
    return this.http.post<FileUrl>(url, id);
  }

  /**
   * Obtiene el listado completo de lotes de importación.
   * @returns Observable con la lista de lotes.
   */
  getLotes(): Observable<GetLote[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.list}`;
    return this.http.get<GetLote[]>(url);
  }

  /**
   * Obtiene los lotes asociados a una operación (BL).
   * @param operation_id - Identificador de la operación.
   * @returns Observable con la lista de lotes de la operación.
   */
  getLotesBl(operation_id: number): Observable<GetLote[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.listBl}${operation_id}`;
    return this.http.get<GetLote[]>(url);
  }

  /**
   * Obtiene el detalle de un lote por su identificador.
   * @param id - Identificador del lote.
   * @returns Observable con el detalle del lote.
   */
  getLoteId(id: number): Observable<LoteId[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.getById}${id}`;
    return this.http.get<LoteId[]>(url);
  }

  /**
   * Obtiene un lote por su identificador en formato de listado.
   * @param id - Identificador del lote.
   * @returns Observable con el lote.
   */
  getLoteId2(id: number): Observable<GetLote[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.getById}${id}`;
    return this.http.get<GetLote[]>(url);
  }

  /**
   * Obtiene la URL del archivo de un lote.
   * @param id - Datos que identifican el archivo del lote.
   * @returns Observable con la URL del archivo.
   */
  getLoteFile(id: loteFile): Observable<FileUrl> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.fileBatch}`;
    return this.http.post<FileUrl>(url, id);
  }

  /**
   * Crea un lote de importación.
   * @param lote - Datos del lote a crear.
   * @returns Observable con la respuesta de la creación.
   */
  createLote( lote: Lote ): Observable<PostLote> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.create}`;
    return this.http.post<PostLote>(url, lote);
  }

  /**
   * Actualiza un lote de importación.
   * @param lote - Datos del lote a actualizar.
   * @returns Observable con el resultado de la operación.
   */
  updateLote( lote: UpdateLote ): Observable<MessageError> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.update}`;
    return this.http.put<MessageError>(url, lote);
  }

  /**
   * Elimina un lote de importación.
   * @param lote - Datos que identifican el lote a eliminar.
   * @returns Observable con el resultado de la operación.
   */
  deleteLote( lote: DeleteLote ): Observable<MessageError> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.delete}`;
    return this.http.delete<MessageError>(url, { headers: new HttpHeaders(), body: {"operation_id":lote.operation_id , "registry_number": lote.registry_number} });
  }

  /**
   * Elimina varios lotes a la vez.
   * @param batch_ids - Lista de identificadores de los lotes a eliminar.
   * @returns Observable con el resultado de la operación.
   */
  deleteAllBatches(batch_ids: number[]): Observable<MessageError> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.deleteAll}`;
    return this.http.delete<MessageError>(url, { headers: new HttpHeaders(), body: {
      batch_ids
    } });
  }

  /**
   * Crea una lista de lotes de forma masiva.
   * @param batchList - Datos de la lista de lotes a crear.
   * @returns Observable con el resultado de la operación.
   */
  createBatchList(batchList: any): Observable<{"error": boolean, "message": string}> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.createBatchList}`;
    return this.http.post<{"error": boolean, "message": string}>(url, batchList);
  }

  /**
   * Obtiene la URL del layout (plantilla) descargable para la carga masiva.
   * @returns Observable con la URL del layout.
   */
  getUrlLayout(): Observable<{url: string}> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.downloadLayout}`;
    return this.http.get<{url: string}>(url);
  }

  /**
   * Obtiene el catálogo de tipos de entrada.
   * @returns Observable con la lista de tipos de entrada.
   */
  getTipoEntrada(): Observable<TipoEntrada[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.entrada.tipoEntrada}`;
    return this.http.get<TipoEntrada[]>(url);
  }

  /**
   * Obtiene una entrada de importación por su identificador.
   * @param id - Identificador de la entrada.
   * @returns Observable con la entrada.
   */
  getEntry(id: number): Observable<Entry[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.entrada.get}${id}`;
    return this.http.get<Entry[]>(url);
  }

  /**
   * Obtiene las entradas de importación de un lote.
   * @param id - Identificador del lote.
   * @returns Observable con la lista de entradas del lote.
   */
  getEntriesByBatch(id: number): Observable<EntriesByBatch[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.entrada.listByBatch}${id}`;
    return this.http.get<EntriesByBatch[]>(url);
  }

  /**
   * Obtiene el listado completo de entradas de importación.
   * @returns Observable con la lista de entradas.
   */
  getEntries(): Observable<Entry[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.entrada.list}`;
    return this.http.get<Entry[]>(url);
  }

  /**
   * Crea una entrada de importación, agregando la lista de ubicaciones formateada.
   * @param entry - Datos de la entrada a crear.
   * @returns Observable con el resultado de la operación.
   */
  createEntry(entry: any): Observable<MessageError> {
    entry.location_list = [
      ...this.amountsPerYardSvc.locationsList.map( (location: any) => ({
        ...location,
        location_id: Number(location.location_id),
        tonnage: Number(location.tonnage),
        pieces: Number(location.pieces) || 0
      })),
    ];
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.entrada.create}`;
    return this.http.post<MessageError>(url, entry);
  }

  /**
   * Actualiza una entrada de importación, agregando la lista de ubicaciones formateada.
   * @param entry - Datos de la entrada a actualizar.
   * @returns Observable con el resultado de la operación.
   */
  updateEntry(entry: any): Observable<MessageError> {
    entry.location_list = [
      ...this.amountsPerYardSvc.locationsList.map( (location: any) => ({
        ...location,
        location_id: Number(location.location_id),
        tonnage: Number(location.tonnage),
        pieces: Number(location.pieces) || 0
      })),
    ];
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.entrada.update}`;
    return this.http.put<MessageError>(url, entry);
  }

  /**
   * Elimina una entrada de importación.
   * @param id - Identificador de la entrada a eliminar.
   * @returns Observable con el resultado de la operación.
   */
  deleteEntry(id: number): Observable<{}> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.entrada.delete}`;
    return this.http.delete<{}>(url, { headers: new HttpHeaders(), body: { id: id } });
  }

  /**
   * Obtiene el catálogo de tipos de salida.
   * @returns Observable con la lista de tipos de salida.
   */
  getTipoSalida(): Observable<SalidaCatalogo[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.tipoSalida}`;
    return this.http.get<SalidaCatalogo[]>(url);
  }

  /**
   * Obtiene el catálogo de tipos de salida con pedimento.
   * @returns Observable con la lista de tipos de salida con pedimento.
   */
  getTipoSalidaPedimento(): Observable<SalidaCatalogo[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.tipoSalidaPedimento}`;
    return this.http.get<SalidaCatalogo[]>(url);
  }

  /**
   * Obtiene el catálogo de tipos de transporte.
   * @returns Observable con la lista de tipos de transporte.
   */
  getTipoTransporte(): Observable<SalidaCatalogo[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.tipoTransporte}`;
    return this.http.get<SalidaCatalogo[]>(url);
  }

  /**
   * Obtiene el catálogo de tipos de unidad.
   * @returns Observable con la lista de tipos de unidad.
   */
  getTipoUnidad(): Observable<SalidaCatalogo[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.tipoUnidad}`;
    return this.http.get<SalidaCatalogo[]>(url);
  }

  /**
   * Obtiene el listado completo de salidas.
   * @returns Observable con la lista de salidas.
   */
  getSalidas(): Observable<SalidaLista[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.list}`;
    return this.http.get<SalidaLista[]>(url);
  }

  /**
   * Obtiene las salidas asociadas a un lote.
   * @param id - Identificador del lote.
   * @returns Observable con la lista de salidas del lote.
   */
  getSalidasByLoteId(id: number): Observable<OutputType[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.getSalidasByLoteId}${id}`;
    return this.http.get<OutputType[]>(url);
  }

  /**
   * Obtiene una salida por su identificador.
   * @param id - Identificador de la salida.
   * @returns Observable con la salida.
   */
  getSalidaById(id: number): Observable<OutputType[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.getSalida}${id}`;
    return this.http.get<OutputType[]>(url);
  }

  /**
   * Obtiene los transportes de una salida, normalizando el campo de número de ticket.
   * @param id - Identificador de la salida.
   * @returns Observable con la lista de transportes.
   */
  getTransportsByOutput(id: number): Observable<Transport[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.transport.list}${id}`;
    return this.http.get<Transport[]>(url).pipe(
      map( transports => {
        return transports.map( transport => {
          transport.no_ticket = transport.no_ticket == 'null' ? '' : transport.no_ticket;
          return transport;
        });
      })
    );
  }

  /**
   * Obtiene el archivo de un transporte de salida.
   * @param id - Identificador del transporte.
   * @param id_weight - Identificador del pesaje.
   * @returns Observable con el archivo del transporte.
   */
  getTransportFile(id: number, id_weight: number): Observable<TransportFile> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.transport.file}`;
    return this.http.post<TransportFile>(url, {id, id_weight});
  }

  /**
   * Crea un transporte de salida.
   * @param transport - Datos del transporte a crear.
   * @returns Observable con el resultado de la operación.
   */
  createTransport(transport: TransportCreate): Observable<MessageError> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.transport.create}`;
    return this.http.post<MessageError>(url, transport);
  }

  /**
   * Actualiza un transporte de salida.
   * @param transport - Datos del transporte a actualizar.
   * @returns Observable con el resultado de la operación.
   */
  updateTransport(transport: TransportCreate): Observable<MessageError> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.transport.create}`;
    return this.http.put<MessageError>(url, transport);
  }

  /**
   * Elimina un transporte de salida.
   * @param id_weight_list - Identificador del pesaje del transporte a eliminar.
   * @returns Observable con el resultado de la operación.
   */
  deleteTransport(id_weight_list: number): Observable<MessageError> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.transport.delete}`;
    return this.http.delete<MessageError>(url, {
      headers: new HttpHeaders(),
      body: {
        id_weight_list
      }
    });
  }

  /**
   * Elimina todos los transportes de una salida.
   * @param outputId - Identificador de la salida.
   * @returns Observable con el resultado de la operación.
   */
  deleteAllTransport(outputId: number): Observable<MessageError> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.transport.deleteAll}`;
    return this.http.delete<MessageError>(url, {
      headers: new HttpHeaders(),
      body: {
        output_id: outputId
      }
    });
  }

  /**
   * Elimina un conjunto de losas (slabs) de un transporte.
   * @param slabsToDelete - Lista de identificadores de las losas a eliminar.
   * @returns Observable con el resultado de la operación.
   */
  deleteSlabs(slabsToDelete: {id: number}[]) {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.transport.deleteSlabs}`;
    return this.http.delete<MessageError>(url, {
      headers: new HttpHeaders(),
      body: slabsToDelete
    });
  }

  /**
   * Crea una salida, normalizando los campos vacíos y agregando la lista de
   * ubicaciones formateada.
   * @param salida - Datos de la salida a crear.
   * @returns Observable con el resultado de la operación.
   */
  createSalida(salida: any): Observable<MessageError> {
    salida.transfer_date = !salida.transfer_date ? null : salida.transfer_date;
    const newOutput: any = salida;
    Object.entries(newOutput).forEach(([clave, valor]) => {
      if ((this.listSelect.includes(clave) && valor === 0) || valor === null || valor === undefined) {
        delete newOutput[clave];
      }
    });
    salida.location_list = [
      ...this.amountsPerYardSvc.locationsList.map( (location: any) => ({
        ...location,
        location_id: Number(location.location_id),
        tonnage: Number(location.tonnage),
        pieces: Number(location.pieces) || 0
      })),
    ];
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.create}`;
    return this.http.post<MessageError>(url, newOutput);
  }

  /**
   * Actualiza una salida, normalizando los campos vacíos y agregando la lista
   * de ubicaciones formateada.
   * @param salida - Datos de la salida a actualizar.
   * @returns Observable con el resultado de la operación.
   */
  updateSalida(salida: any): Observable<MessageError> {
    salida.transfer_date = !salida.transfer_date ? null : salida.transfer_date;
    const newOutput: any = salida;
    Object.entries(newOutput).forEach(([clave, valor]) => {
      if ((this.listSelect.includes(clave) && valor === 0) || valor === null || valor === undefined) {
        delete newOutput[clave];
      }
    });
    salida.location_list = [
      ...this.amountsPerYardSvc.locationsList.map( (location: any) => ({
        ...location,
        location_id: Number(location.location_id),
        tonnage: Number(location.tonnage),
        pieces: Number(location.pieces) || 0
      })),
    ];
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.update}`;
    return this.http.put<MessageError>(url, newOutput);
  }

  /**
   * Elimina una salida.
   * @param id - Identificador de la salida a eliminar.
   * @param tipo - Identificador del tipo de salida.
   * @returns Observable con el resultado de la operación.
   */
  deleteSalida(id: number, tipo: number): Observable<{}> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.delete}`;
    return this.http.delete<{}>(url, { headers: new HttpHeaders(), body: {
      id: id,
      output_type_option_id: tipo
    }});
  }

  /**
   * Obtiene el archivo del ticket de báscula de una salida.
   * @param id - Identificador de la salida.
   * @returns Observable con la URL del archivo.
   */
  fileTicketBascula(id: number): Observable<FileUrl> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.fileTicketBascula}`;
    return this.http.post<FileUrl>(url, {id});
  }

  /**
   * Obtiene el archivo de la orden de transporte de una salida.
   * @param id - Identificador de la salida.
   * @returns Observable con la URL del archivo.
   */
  fileOrdenTransporte(id: number): Observable<FileUrl> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.fileOrdenTransporte}`;
    return this.http.post<FileUrl>(url, {id, id_weight: 0});
  }

  /**
   * Obtiene el archivo de la orden de traspaso de una salida.
   * @param id - Identificador de la salida.
   * @returns Observable con la URL del archivo.
   */
  fileOrdenTraspaso(id: number): Observable<FileUrl> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.fileOrdenTraspaso}`;
    return this.http.post<FileUrl>(url, {id, id_weight: 0});
  }

  /**
   * Obtiene el archivo de salida sin presentación física.
   * @param id - Identificador de la salida.
   * @returns Observable con la URL del archivo.
   */
  fileSinPresentacionFisica(id: number): Observable<FileUrl> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.fileSinPresentacionFisica}`;
    return this.http.post<FileUrl>(url, {id, id_weight: 0});
  }

  /**
   * Obtiene el archivo del oficio de merma de una salida.
   * @param id - Identificador de la salida.
   * @returns Observable con la URL del archivo.
   */
  fileOficioMerma(id: number): Observable<FileUrl> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.fileMerma}`;
    return this.http.post<FileUrl>(url, {id, id_weight: 0});
  }

  /**
   * Obtiene el archivo de convenio de una salida.
   * @param id - Identificador de la salida.
   * @returns Observable con la URL del archivo.
   */
  fileAgreementFile(id: number): Observable<FileUrl> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.fileAgreementFile}`;
    return this.http.post<FileUrl>(url, {id, id_weight: 0});
  }

  /**
   * Obtiene el archivo de retorno de una salida.
   * @param id - Identificador de la salida.
   * @returns Observable con la URL del archivo.
   */
  fileRetorno(id: number): Observable<FileUrl> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.fileRetorno}`;
    return this.http.post<FileUrl>(url, {id, id_weight: 0});
  }

  /**
   * Obtiene la orden de transporte de una salida.
   * @param id - Identificador de la salida.
   * @returns Observable con la URL del archivo.
   */
  getTransportOrder(id: number): Observable<FileUrl> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.fileTransportOrder}${id}`;
    return this.http.get<FileUrl>(url);
  }

  /**
   * Obtiene un lote de exportación del año seleccionado por su identificador.
   * @param batchId - Identificador del lote.
   * @returns Observable con el lote de exportación.
   */
  getExportationBatch(batchId: number): Observable<ExportationBatch[]> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.get}${this.exportBatchesYear}/${batchId}`;
    return this.http.get<ExportationBatch[]>(url);
  }

  /**
   * Lista los lotes de exportación de un año.
   * @param year - Año a consultar.
   * @returns Observable con la lista de lotes de exportación.
   */
  listExportationBatchByYear(year: number): Observable<ExportationBatch[]> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.list}/${year}`;
    return this.http.get<ExportationBatch[]>(url);
  }

  /**
   * Obtiene el archivo de un lote de exportación.
   * @param batchId - Número de registro del lote.
   * @returns Observable con el archivo del lote.
   */
  getExportationBatchFile(batchId: number): Observable<FileBatchExportation> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.file}`;
    return this.http.post<FileBatchExportation>(url, {registry_number: batchId});
  }

  /**
   * Obtiene el archivo de mercancía embargada de un lote de exportación.
   * @param registry_number - Número de registro del lote.
   * @param lot_number - Número de lote.
   * @returns Observable con el archivo de mercancía embargada.
   */
  getExportationEmbargoedFile(registry_number: number, lot_number: number): Observable<FileBatchExportation> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.fileEmbargoedMerchandise}`;
    return this.http.post<FileBatchExportation>(url, {registry_number, lot_number});
  }

  /**
   * Obtiene los registros previos de un lote de exportación.
   * @param id - Identificador del lote.
   * @returns Observable con los registros previos.
   */
  getExportationPreviousRegistration( id: number ): Observable<PreviousRegistration[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.loteExportacion.previousRegistration}${id}`;
    return this.http.get<PreviousRegistration[]>(url);
  }

  /**
   * Obtiene la mercancía embargada de un lote de exportación.
   * @param id - Identificador del lote.
   * @returns Observable con la mercancía embargada.
   */
  getExportationEmbargoedMerchandise( id: number ): Observable<EmbargoedMerchandise[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.loteExportacion.embargoedMerchandise}${id}`;
    return this.http.get<EmbargoedMerchandise[]>(url);
  }

  /**
   * Crea un lote de exportación.
   * @param batch - Datos del lote a crear.
   * @param year - Año del lote; por defecto 2025.
   * @returns Observable con la respuesta de la creación.
   */
  createExportationBatch(batch: any, year: number = 2025): Observable<ResponseCreateBatchExportation> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.create}/${year}`;
    return this.http.post<ResponseCreateBatchExportation>(url, batch);
  }

  /**
   * Actualiza un lote de exportación.
   * @param batch - Datos del lote a actualizar.
   * @param year - Año del lote; por defecto 2025.
   * @returns Observable con la respuesta de la actualización.
   */
  updateExportationBatch(batch: any, year: number = 2025): Observable<{}> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.update}/${year}`;
    return this.http.put<{}>(url, batch);
  }

  /**
   * Elimina un lote de exportación.
   * @param batchId - Número de registro del lote a eliminar.
   * @param year - Año del lote; por defecto 2025.
   * @returns Observable con la respuesta de la eliminación.
   */
  deleteExportationBatch(batchId: number, year: number = 2025): Observable<deleteResponse> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.delete}/${year}`;
    return this.http.delete<deleteResponse>(url, { headers: new HttpHeaders(), body: {
      registry_number: batchId,
    }});
  }

  /**
   * Obtiene el catálogo de líneas de transporte.
   * @returns Observable con la lista de líneas de transporte.
   */
  getListTransportLine(): Observable<TranportLine[]> {
    const url: string =`${GLOBAL.url}${GLOBAL.lotes.listTransportLine}`;
    return this.http.get<TranportLine[]>(url);
  }

  /**
   * Obtiene el catálogo de tipos de entrada de exportación.
   * @returns Observable con la lista de tipos de entrada.
   */
  getListEntriesType(): Observable<TranportLine[]> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.entradas.entriesType}`;
    return this.http.get<TranportLine[]>(url);
  }

  /**
   * Obtiene los transportes de una entrada de exportación, normalizando el
   * campo de número de ticket.
   * @param id - Identificador de la entrada.
   * @returns Observable con la lista de transportes.
   */
  getExportTransportsByOutput(id: number): Observable<ExportTransport[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.loteExportacion.entradas.transport.list}${id}`;
    return this.http.get<ExportTransport[]>(url).pipe(
      map( transports => {
        return transports.map( transport => {
          transport.no_ticket = transport.no_ticket == 'null' ? '' : transport.no_ticket;
          return transport;
        });
      })
    );
  }

  /**
   * Obtiene el archivo de un transporte de entrada de exportación.
   * @param id - Identificador del transporte.
   * @param id_weight - Identificador del pesaje.
   * @returns Observable con el archivo del transporte.
   */
  getExportTransportFile(id: number, id_weight: number): Observable<TransportFile> {
    const url: string = `${GLOBAL.url}${GLOBAL.loteExportacion.entradas.transport.file}`;
    return this.http.post<TransportFile>(url, {id, id_weight});
  }

  /**
   * Crea un transporte de entrada de exportación.
   * @param transport - Datos del transporte a crear.
   * @returns Observable con el resultado de la operación.
   */
  createExportTransport(transport: ExportTransportCreate): Observable<MessageError> {
    const url: string = `${GLOBAL.url}${GLOBAL.loteExportacion.entradas.transport.create}`;
    return this.http.post<MessageError>(url, transport);
  }

  /**
   * Actualiza un transporte de entrada de exportación.
   * @param transport - Datos del transporte a actualizar.
   * @returns Observable con el resultado de la operación.
   */
  updateExportTransport(transport: ExportTransportCreate): Observable<MessageError> {
    const url: string = `${GLOBAL.url}${GLOBAL.loteExportacion.entradas.transport.update}`;
    return this.http.put<MessageError>(url, transport);
  }

  /**
   * Elimina un transporte de entrada de exportación.
   * @param id - Identificador del transporte.
   * @param id_entry - Identificador de la entrada.
   * @returns Observable con el resultado de la operación.
   */
  deleteExportTransport(id: number, id_entry: number): Observable<MessageError> {
    const url: string = `${GLOBAL.url}${GLOBAL.loteExportacion.entradas.transport.delete}`;
    return this.http.delete<MessageError>(url, {
      headers: new HttpHeaders(),
      body: {
        id,
        id_entry
      }
    });
  }

  /**
   * Elimina todos los transportes de una entrada de exportación.
   * @param entryId - Identificador de la entrada.
   * @returns Observable con el resultado de la operación.
   */
  deleteAllEntryTransport(entryId: number): Observable<MessageError> {
    const url: string = `${GLOBAL.url}${GLOBAL.loteExportacion.entradas.transport.deleteAll}`;
    return this.http.delete<MessageError>(url, {
      headers: new HttpHeaders(),
      body: {
        entry_id: entryId
      }
    });
  }

  // Export Transport

  /**
   * Obtiene los transportes de una salida de exportación, normalizando el
   * campo de número de ticket.
   * @param id - Identificador de la salida.
   * @returns Observable con la lista de transportes de la salida.
   */
  getExportTransportListByOutput(id: number): Observable<ExportTransportOutput[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.loteExportacion.salidas.transport.list}${id}`;
    return this.http.get<ExportTransportOutput[]>(url).pipe(
      map( transports => {
        return transports.map( transport => {
          transport.no_ticket = transport.no_ticket == 'null' ? '' : transport.no_ticket;
          return transport;
        });
      })
    );
  }

  /**
   * Crea un transporte de salida de exportación.
   * @param transport - Datos del transporte a crear.
   * @returns Observable con el resultado de la operación.
   */
  createExportTransportOutput(transport: any): Observable<MessageError> {
    const url: string = `${GLOBAL.url}${GLOBAL.loteExportacion.salidas.transport.create}`;
    return this.http.post<MessageError>(url, transport);
  }

  /**
   * Actualiza un transporte de salida de exportación.
   * @param transport - Datos del transporte a actualizar.
   * @returns Observable con el resultado de la operación.
   */
  updateExportTransportOutput(transport: any): Observable<MessageError> {
    const url: string = `${GLOBAL.url}${GLOBAL.loteExportacion.salidas.transport.update}`;
    return this.http.put<MessageError>(url, transport);
  }

  /**
   * Elimina un transporte de salida de exportación.
   * @param id - Identificador del transporte a eliminar.
   * @returns Observable con el resultado de la operación.
   */
  deleteExportTransportOutput(id: number): Observable<MessageError> {
    const url: string = `${GLOBAL.url}${GLOBAL.loteExportacion.salidas.transport.delete}`;
    return this.http.delete<MessageError>(url, {
      headers: new HttpHeaders(),
      body: {
        id,
      }
    });
  }

  /**
   * Elimina todos los transportes de una salida de exportación.
   * @param id - Identificador de la salida.
   * @returns Observable con el resultado de la operación.
   */
  deleteAllExportTransportOutput(id: number): Observable<MessageError> {
    const url: string = `${GLOBAL.url}${GLOBAL.loteExportacion.salidas.transport.deleteAll}`;
    return this.http.delete<MessageError>(url, {
      headers: new HttpHeaders(),
      body: {
        output_id: id,
      }
    });
  }

  /**
   * Obtiene el listado completo de entradas de exportación.
   * @returns Observable con la lista de entradas de exportación.
   */
  getListExportationEntry(): Observable<ExportEntry[]> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.entradas.list}`;
    return this.http.get<ExportEntry[]>(url);
  }

  /**
   * Obtiene las entradas de exportación de un lote.
   * @param id - Identificador del lote.
   * @returns Observable con la lista de entradas del lote.
   */
  getListByBatchExportationEntry(id: number): Observable<ExportEntry[]> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.entradas.listByBatch}${id}`;
    return this.http.get<ExportEntry[]>(url);
  }

  /**
   * Obtiene una entrada de exportación por su identificador.
   * @param id - Identificador de la entrada.
   * @returns Observable con la entrada de exportación.
   */
  getExportationEntry(id: number): Observable<ExportEntry[]> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.entradas.get}${id}`;
    return this.http.get<ExportEntry[]>(url);
  }

  /**
   * Obtiene el archivo de una entrada de exportación.
   * @param id - Identificador de la entrada.
   * @returns Observable con el archivo de la entrada.
   */
  getFileExportationEntry(id: number): Observable<FileEntryExportation> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.entradas.file}`;
    return this.http.post<FileEntryExportation>(url, {id});
  }

  /**
   * Crea una entrada de exportación, agregando la lista de ubicaciones formateada.
   * @param entry - Datos de la entrada a crear.
   * @returns Observable con la respuesta de la creación.
   */
  createExportationEntry(entry: any): Observable<EntryResponse> {
    entry.location_list = [
      ...this.amountsPerYardSvc.locationsList.map( (location: any) => ({
        ...location,
        location_id: Number(location.location_id),
        tonnage: Number(location.tonnage),
        pieces: Number(location.pieces) || 0
      })),
    ];
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.entradas.create}`;
    return this.http.post<EntryResponse>(url, entry);
  }

  /**
   * Actualiza una entrada de exportación, agregando la lista de ubicaciones formateada.
   * @param entry - Datos de la entrada a actualizar.
   * @returns Observable con la respuesta de la actualización.
   */
  updateExportationEntry(entry: any): Observable<deleteResponse> {
    entry.location_list = [
      ...this.amountsPerYardSvc.locationsList.map( (location: any) => ({
        ...location,
        location_id: Number(location.location_id),
        tonnage: Number(location.tonnage),
        pieces: Number(location.pieces) || 0
      })),
    ];
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.entradas.update}`;
    return this.http.put<deleteResponse>(url, entry);
  }

  /**
   * Elimina una entrada de exportación.
   * @param id - Identificador de la entrada a eliminar.
   * @returns Observable con la respuesta de la eliminación.
   */
  deleteExportationEntry(id: number): Observable<{}> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.entradas.delete}`;
    return this.http.delete<{}>(url, { headers: new HttpHeaders(), body: {
      id,
    }});
  }

  /**
   * Crea una carta membretada para un lote de exportación.
   * @param letter - Datos de la carta membretada a crear.
   * @returns Observable con el archivo de la carta membretada creada.
   */
  createMembratedLetter(letter: MembratedLetter): Observable<FileBatchExportation> {
    const url: string = `${GLOBAL.url}${GLOBAL.loteExportacion.entradas.cartaMembretada.create}`;
    return this.http.post<FileBatchExportation>(url, letter);
  }

  /**
   * Obtiene la carta membretada de un lote de exportación.
   * @param id_export_batch - Identificador del lote de exportación.
   * @returns Observable con el archivo de la carta membretada.
   */
  getMembratedLetter(id_export_batch: number): Observable<FileBatchExportation> {
    const url: string = `${GLOBAL.url}${GLOBAL.loteExportacion.entradas.cartaMembretada.get}`;
    return this.http.post<FileBatchExportation>(url, {id_export_batch});
  }

  /**
   * Crea una salida de exportación, agregando la lista de ubicaciones formateada.
   * @param output - Datos de la salida a crear.
   * @returns Observable con la respuesta de la creación.
   */
  createExportOutput(output: ExportOutput): Observable<OuputResponse> {
    output.location_list = [
      ...this.amountsPerYardSvc.locationsList.map( (location: any) => ({
        ...location,
        location_id: Number(location.location_id),
        tonnage: Number(location.tonnage),
        pieces: Number(location.pieces) || 0
      })),
    ];
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.salidas.create}`;
    return this.http.post<OuputResponse>(url, output);
  }

  /**
   * Actualiza una salida de exportación, agregando la lista de ubicaciones formateada.
   * @param output - Datos de la salida a actualizar.
   * @returns Observable con la respuesta de la actualización.
   */
  updateExportOutput(output: ExportOutput): Observable<deleteResponse> {
    output.location_list = [
      ...this.amountsPerYardSvc.locationsList.map( (location: any) => ({
        ...location,
        location_id: Number(location.location_id),
        tonnage: Number(location.tonnage),
        pieces: Number(location.pieces) || 0
      })),
    ];
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.salidas.update}`;
    return this.http.put<deleteResponse>(url, output);
  }

  /**
   * Elimina una salida de exportación.
   * @param id - Identificador de la salida a eliminar.
   * @returns Observable con la respuesta de la eliminación.
   */
  deleteExportOutput(id: number): Observable<{}> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.salidas.delete}`;
    return this.http.delete<{}>(url, { headers: new HttpHeaders(), body: {
      id,
    }});
  }

  /**
   * Obtiene las salidas de un lote de exportación.
   * @param id - Identificador del lote.
   * @returns Observable con la lista de salidas del lote.
   */
  getListByBatchExportationOutput(id: number): Observable<ExportOutput[]> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.salidas.listByBatch}${id}`;
    return this.http.get<ExportOutput[]>(url);
  }

  /**
   * Obtiene una salida de exportación por su identificador.
   * @param id - Identificador de la salida.
   * @returns Observable con la salida de exportación.
   */
  getExportOutput(id: number): Observable<ExportOutput[]> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.salidas.get}${id}`;
    return this.http.get<ExportOutput[]>(url);
  }

  /**
   * Obtiene el archivo de una salida de exportación.
   * @param id - Identificador de la salida.
   * @returns Observable con el archivo de la salida.
   */
  getExportOutputFile(id: number): Observable<FileEntryExportation> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.salidas.file}`;
    return this.http.post<FileEntryExportation>(url, {id});
  }

  /**
   * Obtiene el archivo de retiro de una salida de exportación.
   * @param id - Identificador de la salida.
   * @returns Observable con el archivo de retiro.
   */
  getExportOutputFileWithdrawal(id: string): Observable<FileEntryExportation> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.salidas.fileWithdrawal}`;
    return this.http.post<FileEntryExportation>(url, {id});
  }

  /**
   * Obtiene la orden de transporte de una salida de exportación o cabotaje.
   * @param operation_type - Tipo de operación.
   * @param output_id - Identificador de la salida.
   * @returns Observable con el archivo de la orden de transporte.
   */
  getTransportOrderExpCab(operation_type: number, output_id: number): Observable<FileBatchExportation> {
    const url: string = `${GLOBAL.url}${GLOBAL.lotes.salida.fileTransportOrderExpCab}`;
    return this.http.post<FileBatchExportation>(url, {operation_type, output_id});
  }

  /**
   * Obtiene el archivo de merma de una salida de exportación.
   * @param id - Identificador de la salida.
   * @returns Observable con el archivo de merma.
   */
  getExportOutputMermaFile(id: number): Observable<FileEntryExportation> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.salidas.fileMerma}`;
    return this.http.post<FileEntryExportation>(url, {id});
  }

  /**
   * Obtiene el archivo de convenio de una salida de exportación.
   * @param id - Identificador de la salida.
   * @returns Observable con el archivo de convenio.
   */
  getExportOutputAgreementFile(id: number): Observable<FileEntryExportation> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.salidas.fileAgreement}`;
    return this.http.post<FileEntryExportation>(url, {id});
  }

  /**
   * Obtiene los lotes disponibles para transferencia.
   * @param id - Identificador del lote de referencia.
   * @returns Observable con la lista de lotes disponibles para transferencia.
   */
  getBatchesAvailableTransfer(id: number): Observable<BatchesAvailableTransfer[]> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.salidas.batchesAvailableTransfer}${id}`;
    return this.http.get<BatchesAvailableTransfer[]>(url);
  }

  /**
   * Obtiene los tipos de salida de exportación disponibles.
   * @returns Observable con la lista de tipos de salida.
   */
  getExportOutputTypes(): Observable<ExportOutputType[]> {
    const url: string =`${GLOBAL.url}${GLOBAL.loteExportacion.salidas.tipos}`;
    return this.http.get<ExportOutputType[]>(url);
  }

  /**
   * Asigna un barco de exportación y obtiene sus lotes asociados.
   * @param idShip - Identificador del barco.
   * @returns Observable con los lotes del barco.
   */
  assignExportShip(idShip: number): Observable<GetLote[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.loteExportacion.salidas.asignarBarco}${idShip}/exportacion`;
    return this.http.get<GetLote[]>(url);
  }

  /**
   * Asigna el valor "No asignado." al número de lote y a la dirección del
   * cliente cuando están vacíos.
   * @param batch - Lista de lotes de exportación a procesar.
   * @returns La lista con los campos normalizados.
   */
  idToName(batch: ExportationBatch[]) {
    return batch.map( batch => {
      batch.customer_lot_number = batch.customer_lot_number || 'No asignado.';
      batch.address = batch.address || 'No asignado.';
      return batch;
    });
  }

  /**
   * Ordena un arreglo de objetos de forma descendente según la clave indicada.
   * @param array - Arreglo a ordenar.
   * @param key - Clave del objeto por la que se ordena.
   * @returns El arreglo ordenado.
   */
  sortArray<T>(array: T[], key: keyof T): T[] {
    return array = array.sort(function (a, b) {
      if (a[key] > b[key]) {
        return -1;
      }
      if (a[key] < b[key]) {
        return 1;
      }
      return 0;
    });
  }

  /**
   * Indica si alguno de los lotes de la lista contiene alguno de los materiales dados.
   * @param batchList - Lista de lotes a evaluar.
   * @param materials - Lista de identificadores de material a buscar.
   * @returns `true` si algún lote contiene alguno de los materiales.
   */
  batchListHasTheseMaterials(batchList:  GetLote[],materials: number[]): boolean {
    return batchList.some(batch => materials.includes(batch.material_id));
  }
}
